// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TDeleteConversationFileRequestPayload,
  TDeleteConversationFileResponsePayload,
  TUploadConversationFileRequest,
  TUploadConversationFileResponsePayload,
} from './conversation-files.types.ts';

export const createConversationFilesApi = (transport: TApiTransport) => ({
  /** Deletes a conversation file */
  deleteConversationFile: (
    payload: TDeleteConversationFileRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteConversationFileRequestPayload,
      TDeleteConversationFileResponsePayload
    >('/delete_conversation_file', payload, options),

  /** Uploads a file to a conversation */
  uploadConversationFile: (
    payload: TUploadConversationFileRequest,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUploadConversationFileRequest,
      TUploadConversationFileResponsePayload
    >('/upload_conversation_file', payload, {
      ...options,
      contentType: 'multipart/form-data',
    }),
});
